/**
 * @author: annie
 * Anything related to Messages templates.
 */

/*************************************************
 ******** Edit Message Template Controller ********
 *************************************************/

var messagesTemplateModule = angular.module('MessagesTemplateController', []);
messagesTemplateModule.controller('MessagesTemplateController', ['$scope', 'campaignService', '$location', '$routeParams', 'constantService', 'tabInfoService', '$q', 'modalService', 'Draggable', '$timeout', 'draggableTemplate', 'loadType', 'TinyMceMessageToContent', 'ContentToTinyMceMessage', '1SecondNotificationBar', '$filter',
    function ($scope, campaignService, $location, $routeParams, constantService, tabInfoService, $q, modalService, Draggable, $timeout, draggableTemplate, loadType, TinyMceMessageToContent, ContentToTinyMceMessage, NotificationBar, $filter) {
        $scope.messageContent = {};
        $scope.showAddRequisition = true;
        $scope.showAddCampaign = true;
        $scope.showAddLink = true;
        $scope.content = {};
        $scope.links = {};
        $scope.links.custom = [];
        $scope.links.requisition = [];
        $scope.links.reqIds = [];
        $scope.links.campaign = [];
        $scope.accountsArray = [];

        $scope.dialogs = {};
        $scope.dialogs.draggableLinks = false;

        var linkCounter = 1;
        var accountsCount = 0;
        $scope.sendTime = 'sendNow';
        $scope.totalChar = 1000;
        $scope.messageContent.characterCount = 0;
        $scope.messageContent.htmlMessage = '';
        var invalidCharacters = false;
        $scope.campaignObj = {};

        //ajax calls
        campaignService.getDetails();
        campaignService.getAccounts({
            status: 'ACTIVE'
        }, function (data) {
            $scope.accountsArray = data.resultList;
            accountsCount = data.resultList.length;

            if (accountsCount === 0) {
                $scope.accountExists = false;
                $scope.getStarted = true;
            } else {
                $scope.accountExists = true;
                $scope.getStarted = false;
                if (accountsCount === 1) {
                    $scope.accountsArray[0].socialId = true;
                } else {
                    $scope.multipleAccounts = true;
                    $scope.checkboxError = true;
                }
                $scope.checkCheckboxes();
                if ($scope.multipleAccounts) {
                    $scope.checkCheckboxParent();
                }
                $scope.checkboxError = false;
            }
        });



        //modals
        //custom link   
        $scope.addCustomLink = function (link) {
            var deferredObj = editLinkMetadata(link);
            // collect metadata from user.  Use addAnyLink as a callback.
            deferredObj.then(function (successVal) {
                var newContent = '[custom-link-{0}]'.format(successVal.actionName);
                var metadata = {
                    actionName: successVal.actionName,
                    actionUrl: successVal.actionUrl
                };
                var newLink = Draggable(successVal.actionName, newContent, draggableTemplate, metadata);
                if (link) {
                    if ($scope.messageContent.htmlMessage !== undefined)
                        $scope.messageContent.htmlMessage = $scope.messageContent.htmlMessage.split(link.metadata.templateVariable).join(newLink.metadata.templateVariable);
                    angular.extend(link, newLink);
                } else {
                    $scope.links.custom.push(newLink);
                    $scope.showAddLink = ($scope.links.custom.length < 3);
                }
            });
        };

        var editLinkMetadata = function (link) {
            var resultData = {};
            if (angular.isDefined(link)) {
                resultData = {
                    metadata: {
                        actionName: link.text,
                        actionUrl: link.metadata.actionUrl
                    }
                };
            }
            if ($scope.links && $scope.links.custom) {
                resultData.customTemplates = $scope.links.custom;
            }
            if (link && link.text) {
                resultData.currentLinkText = link.text;
            }
            var deferred = $q.defer();
            modalService.getLinkDetails(resultData, deferred);
            return deferred.promise;
        };

        //requisition modal
        $scope.addRequisition = function (link) {
            campaignService.getRequisitionFilters({}, function (results) {
                var deferredService = $q.defer();
                modalService.selectRequisition(results, deferredService);
                deferredService.promise.then(function (successVal) {
                    if ($scope.links.reqIds && $scope.links.reqIds.length > 0 && $.inArray(successVal.EId, $scope.links.reqIds) !== -1) {
                        //The requisition link token already exists for the campaign.
                    } else {
                        var metadata = {
                            jobEId: successVal.EId,
                            title: successVal.title
                        };
                        if (successVal.requisitionId) {
                            metadata.requisitionId = successVal.requisitionId.trim();
                        }
                        var reqTitleText = campaignService.getReqTitleText(successVal.title, successVal.requisitionId);
                        var newLink = Draggable(reqTitleText, '[' + reqTitleText + ']', draggableTemplate, metadata);
                        //link is defined when we are trying to edit a requisition link rather than adding a new requisition
                        if (link) {
                            if ($scope.links.reqIds && $scope.links.reqIds.indexOf(link.metadata.jobEId) !== -1) {
                                //When editing a requisition, we have to make sure that  $scope.links.reqIds has the updated list of reqIds
                                $scope.links.reqIds.splice($scope.links.reqIds.indexOf(link.metadata.jobEId), 1);
                            }
                            angular.extend(link, newLink);
                            //Adding the new edited requisitions jobEId to $scope.links.reqIds
                            $scope.links.reqIds.push(newLink.metadata.jobEId);
                        } else {
                            $scope.links.requisition.push(newLink);
                            $scope.links.reqIds.push(successVal.EId);
                            $scope.showAddRequisition = false;
                        }
                    }
                });
            });
        };

        var editRequisitionMetadata = function (link) {
            var resultData = link || {};
            var deferred = $q.defer();
            // open edit box for requisitions
            modalService.selectRequisition(resultData, deferred);
            return deferred.promise;
        };

        //campaign modal
        $scope.addCampaign = function (link) {
            var deferredObj = editCampaignMetadata(link);
            deferredObj.then(function (successVal) {
                var newText = 'Campaign Link ({0})'.format(successVal.name);
                var newLink = Draggable(newText, '[Campaign-Link]', draggableTemplate, successVal);
                if (link) {
                    angular.extend(link, newLink);
                } else {
                    $scope.links.campaign.push(newLink);
                    $scope.showAddCampaign = false;
                }
            });
        };

        var editCampaignMetadata = function (link) {
            var resultData = link || {};
            var deferred = $q.defer();
            // open edit box for requisitions
            modalService.selectWebCampaign(resultData, deferred);
            return deferred.promise;
        };

        //checkboxes:
        $scope.sendTime = 'sendNow';
        $scope.totalChar = 1000;

        var findTwitter = function () {
            var found = false;
            for (var i = 0; i < $scope.accountsArray.length; i++) {
                if ($scope.accountsArray[i].socialId === true && $scope.accountsArray[i].platform === 'TWITTER') {
                    found = true;
                }
            }

            if (found) {
                $scope.totalChar = 200;
            } else {
                $scope.totalChar = 1000;
            }
        };

        $scope.checkCheckboxes = function () {
            if (accountsCount === 1) {
                //  $scope.parent = !$scope.parent;
                $scope.checkboxError = !$scope.checkboxError;
            } else {
                if ($('.socialCheckboxes input:checkbox:checked').length === 0) {
                    $scope.checkboxError = true;
                } else {
                    $scope.checkboxError = false;
                }

                var chkChild = document.querySelectorAll('input[name^="child_"]').length;
                var chkChildChecked = document.querySelectorAll('input[name^="child_"]:checked').length;
                if (chkChild === chkChildChecked) {
                    $scope.parent = true;
                } else {
                    $scope.parent = false;
                }
            }
            findTwitter();
        };

        $scope.checkCheckboxParent = function () {
            if ($scope.parent === false) {
                $scope.checkboxError = true;
            } else {
                $scope.checkboxError = false;
            }

            for (var i = 0; i < accountsCount; i++) {
                $scope.accountsArray[i].socialId = $scope.parent;
            }
            findTwitter();
        };

        //
        // //message characters count
        // $scope.$watch('messageContent.characterCount',function(){
        //  console.log('hello');
        //  if($scope.totalChar - $scope.messageContent.characterCount < 0 ){
        //      invalidCharacters = true;
        //  }else{
        //      invalidCharacters = false;
        //  }
        // })

        //Action for cancel
        $scope.cancelTemplate = function () {
            $location.path('campaign/social/Messages/' + $routeParams.ceid);
        };

        //Scheduling
        $scope.scheduledTimeSelected = undefined;
        $scope.timeZoneSelected = undefined;

        $scope.sheduledTime = [{
                id: 8,
                text: i18n['JV_SOCIALMESSAGESTEMPLATE_MORNING']
            },
            {
                id: 12,
                text: i18n['JV_SOCIALMESSAGESTEMPLATE_AFTERNOON']
            },
            {
                id: 18,
                text: i18n['JV_SOCIALMESSAGESTEMPLATE_EVENING']
            }
        ];

        $scope.timeZone = [];
        campaignService.getTimeZone({}, function (results) {
            $scope.timeZone = results.resultList;
        });

        // error validation for scheduling
        $scope.checkDate = function () {
            if ($scope.sendTime === 'sendFuture' && $scope.date === undefined) {
                $scope.timeNotSelectedError = true;
            } else {
                $scope.timeNotSelectedError = false;
            }
        };

        $scope.$watch('date', function (newValue) {
            if ($scope.sendTime === 'sendFuture' && newValue === undefined) {
                $scope.timeNotSelectedError = true;
            } else {
                $scope.timeNotSelectedError = false;
            }
        });

        //save Action                       
        $scope.saveTemplate = function () {
            //error checking before saving.
            invalidCharacters = $scope.totalChar - $scope.characterCount < 0;
            if ($scope.checkboxError || $scope.timeNotSelectedError || $scope.pastEmailError || invalidCharacters) {
                window.JV.showDropDownMessageError(constantService.MESSAGES_HAS_ERRORS);
                return;
            }

            var _htmlMessage = massageRichMessage($scope.messageContent.htmlMessage);

            var customActionTemplates = [];
            angular.forEach($scope.links.custom, function (draggable) {
                customActionTemplates.push(draggable.metadata);
            });

            //metaData object
            var metaDataObj = {
                actions: customActionTemplates
            };

            if ($scope.links.requisition && $scope.links.requisition.length > 0) {
                var reqLinkStructures = [];
                var reqLinkMetadata = '';
                angular.forEach($scope.links.requisition, function (requisitionLink) {
                    reqLinkMetadata = requisitionLink.metadata;
                    if (reqLinkMetadata) {
                        reqLinkStructures.push({
                            'jobEId': reqLinkMetadata.jobEId,
                            'jobTemplateVariable': reqLinkMetadata.templateVariable,
                            'jobTitle': reqLinkMetadata.title,
                            'requisitionId': reqLinkMetadata.requisitionId
                        });
                    }
                });
                if (reqLinkStructures && reqLinkStructures.length > 0) {
                    metaDataObj.reqStructures = reqLinkStructures;
                }
            }

            if ($scope.links.campaign && $scope.links.campaign.length > 0) {
                var tmp = $scope.links.campaign[0].metadata;
                metaDataObj.campaignEId = tmp.eid;
                metaDataObj.campaignTemplateVariable = tmp.templateVariable;
            }

            //accounts eid
            var campaignEId = [];
            for (var k = 0; k < accountsCount; k++) {
                if ($scope.accountsArray[k].socialId === true) {
                    campaignEId.push($scope.accountsArray[k].eid);
                }
            }

            //save object
            var _msgObj = {
                'htmlMessage': _htmlMessage,
                'metaData': JSON.stringify(metaDataObj),
                'campaignDestinationEids': campaignEId,
                'scheduleDate': $scope.date,
                'scheduleHour': $scope.scheduledTimeSelected['id'],
                'scheduleTimeZone': $scope.timeZoneSelected.openSysId
            };

            if ($scope.sendTime === 'sendNow') {
                var removeProperties = ['scheduleDate', 'scheduleTimeZone', 'scheduleHour'];
                for (var i = 0, j = removeProperties.length; i < j; i++) {
                    delete _msgObj[removeProperties[i]];
                }
            }
            if (angular.isDefined($routeParams.meid) && loadType !== 'COPY') {
                _msgObj.id = $scope.messageContent.id;
            }

            //ajax call
            campaignService.saveEmailTemplate(_msgObj, function (result) {
                if (result.status === 'ok') {
                    NotificationBar.PostMessage(i18n['JV_SOCIALMESSAGESTEMPLATE_YOUR_MESSAGE_HAS_BEEN_SAVED'], 'InformationBar')
                    $timeout(function () {
                        $location.path('campaign/social/Messages/' + $routeParams.ceid);
                    }, 500);
                } else {
                    window.JV.showDropDownMessageError(constantService.MESSAGE_TEMPLATE_UNSAVED);
                }
            });

        };

        var massageRichMessage = function (message) {
            //Defined in Base Controller.
            var allLinks = [].concat($scope.links.custom).concat($scope.links.requisition).concat($scope.links.campaign);
            message = TinyMceMessageToContent(message, allLinks, 'templateVariable');
            message = message.split('<br>').join(' ').split('\n').join(' ');
            message = $('<div></div>').html(message).text();
            return message;
        };

        $scope.addAccount = function () {
            $location.path('campaign/social/accounts/' + $routeParams.ceid);
        };

        function getSelectedTimeZone(openSysId) {
            for (var i = 0; i < $scope.timeZone.length; i++) {
                if (openSysId === $scope.timeZone[i].openSysId) {
                    return $scope.timeZone[i];
                }
            }
            return null;
        }

        if (loadType === 'EDIT' || 'COPY') {
            campaignService.getEmailContents({}, function (result) {
                var result = angular.copy(result);
                angular.forEach(result.analyticsByMessage, function (item) {
                    if (item.id === $routeParams.meid) {
                        // transition the data before injecting it in the DOM.
                        if (typeof item.metaData && $.trim(item.metaData) !== '') {

                            var metaData = JSON.parse(item.metaData);
                            if (metaData != null && angular.isDefined(metaData)) {
                                if (angular.isDefined(metaData.actions) && metaData.actions.length > 0) {
                                    angular.forEach((metaData.actions || []), function (customLink) {
                                        $scope.links.custom.push(Draggable(customLink.actionName, customLink.templateVariable, draggableTemplate, customLink));
                                    });
                                }
                                angular.forEach(metaData.reqStructures, function (reqStructure) {
                                    if (reqStructure && angular.isDefined(reqStructure.jobTemplateVariable) && $.trim(reqStructure.jobTemplateVariable) !== '') {
                                        var reqTitleText = campaignService.getReqTitleText(reqStructure.jobTitle, reqStructure.requisitionId);
                                        $scope.links.requisition.push(Draggable(reqTitleText, reqStructure.jobTemplateVariable, draggableTemplate, {
                                            jobEId: reqStructure.jobEId,
                                            requisitionId: reqStructure.requisitionId
                                        }));
                                        $scope.links.reqIds.push(reqStructure.jobEId);
                                    }
                                });
                                if (angular.isDefined(metaData.campaignTemplateVariable) && $.trim(metaData.campaignTemplateVariable) !== '') {
                                    $scope.links.campaign.push(Draggable(metaData.campaignTitle, metaData.campaignTemplateVariable, draggableTemplate, {
                                        eid: metaData.campaignEId,
                                        name: metaData.campaignTitle
                                    }));
                                }
                                var allLinks = [].concat($scope.links.custom).concat($scope.links.requisition).concat($scope.links.campaign);
                                item.htmlMessage = ContentToTinyMceMessage(item.htmlMessage, allLinks);
                            }
                        }

                        angular.extend($scope.messageContent, item);
                        $scope.messageContent.characterCount = $('<div></div>').html(item.htmlMessage).text().length;
                        if (loadType !== 'COPY') {
                            var sentDate = new Date(item.date);
                            $scope.date = $filter('localeDateTime')(sentDate, 'shortDate', 'MM/dd/yyyy');
                            var sentTime = sentDate.getHours();

                            if (sentTime > 8 && sentTime <= 12) {
                                $scope.sheduledTime = [{
                                        id: 12,
                                        text: i18n['JV_SOCIALMESSAGESTEMPLATE_AFTERNOON']
                                    },
                                    {
                                        id: 8,
                                        text: i18n['JV_SOCIALMESSAGESTEMPLATE_MORNING']
                                    },
                                    {
                                        id: 18,
                                        text: i18n['JV_SOCIALMESSAGESTEMPLATE_EVENING']
                                    }
                                ];
                            } else if (sentTime > 12) {
                                $scope.sheduledTime = [{
                                        id: 18,
                                        text: i18n['JV_SOCIALMESSAGESTEMPLATE_EVENING']
                                    },
                                    {
                                        id: 12,
                                        text: i18n['JV_SOCIALMESSAGESTEMPLATE_AFTERNOON']
                                    },
                                    {
                                        id: 8,
                                        text: i18n['JV_SOCIALMESSAGESTEMPLATE_MORNING']
                                    }
                                ];
                            }

                            $scope.sendTime = 'sendFuture';
                            for (var i = 0; i < $scope.accountsArray.length; i++) {
                                for (var j = 0; j < item.analyticsByNetwork.length; j++) {
                                    if ($scope.accountsArray[i].eid === item.analyticsByNetwork[j].networkEId) {
                                        $scope.accountsArray[i].socialId = true;
                                        $scope.checkCheckboxes();
                                        $scope.checkboxError = false;
                                    }
                                }
                            }
                        }

                    }
                });
                $scope.timeZoneSelected = getSelectedTimeZone(result.userTimeZone);
            });
        }
    }
]);


/*************************************************
 **************** Messages Controller ************
 *************************************************/
var SocialMessagesModule = angular.module('SocialMessagesCtrl', []);
SocialMessagesModule.controller('SocialMessagesCtrl', ['$scope', 'campaignService', '$location', '$routeParams', 'constantService', 'tabInfoService', 'modalService', '$q',
    function ($scope, campaignService, $location, $routeParams, constantService, tabInfoService, modalService, $q) {
        campaignService.getDetails();
        $scope.showLoading = true;
        $scope.showNoResults = false;
        $scope.messageList = [];
        $scope.originalMessageList = [];

        //Render the results with the ajax call.
        $scope.$on('emailContentsReceived', function (event, results) {

            $scope.showLoading = false;
            if (results.analyticsByMessage.length === 0) {
                $location.path('campaign/social/editMessage/' + $routeParams.ceid);
            }

            $scope.messageList = results.analyticsByMessage;

            for (var i = 0; i < results.analyticsByMessage.length; i++) {
                $scope.messageList[i].notPublished = $scope.messageList[i].published;
            }

        });

        //Need to add page loading image

        campaignService.getEmailContents(null, null);

        $scope.addCampaign = function () {};

        //BUTTONS
        $scope.editMessage = function (index) {
            var _messageId = $scope.messageList[index].id;
            $location.path('campaign/social/editMessage/' + $routeParams.ceid + '/' + _messageId + '/' + 'edit');
        };

        $scope.copyMessage = function (index) {
            var _messageId = $scope.messageList[index].id;
            $location.path('campaign/social/editMessage/' + $routeParams.ceid + '/' + _messageId + '/' + 'copy');
        };

        $scope.deleteMessage = function (index) {
            campaignService.removeEmailTemplate({
                contentEid: $scope.messageList[index]['id']
            }, function (result) {
                if (!!result.status && result.status === 'ok') {
                    window.JV.showDropDownMessage(constantService.TEMPLATE_DELETE);
                    campaignService.getEmailContents();
                } else {
                    window.JV.showDropDownMessageError(constantService.TEMPLATE_NOT_DELETED);
                }
            });
        };

        $scope.openRichMessage = function () {
            $location.path('campaign/social/editMessage/' + $routeParams.ceid);
        };

        tabInfoService();
    }
]);